import { render } from "./ModalQuickLoad.vue?vue&type=template&id=c01a88d8"
import script from "./ModalQuickLoad.vue?vue&type=script&lang=js"
export * from "./ModalQuickLoad.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__